import React, {useState} from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";
import Login from 'dugoly-login'

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
  state = {
    customer_ID:'',
    transaction_ID:'',
    displayer:"form",
    number: "",
    name: "",
    expiry: "",
    cvc: "",
    amount:"",
    business_name:"",
    date:""
  }

  handleInputChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  getCookie=(cname)=> {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  handleSubmit = e => {
    e.preventDefault();
    const uid=this.getCookie("uid")
    const token=this.getCookie("dugolyToken")
    if(!uid||!token){alert("you have to login by dugoly to secure the data  \n The login button is at the top of the page")}
    else{
const data={
  customer_ID:this.state.customer_ID,
  transaction_ID:this.state.transaction_ID,
cookies:`uid=${this.getCookie("uid")};dugolyToken=${this.getCookie("dugolyToken")}`
}
fetch("https://dugoly.com/api/receive_credit", {
  // fetch("http://localhost:3002/api/receive_credit", {
      method: "POST", 
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => {
      console.log("Request complete! response:", res);
      const date=new Date(res.date).toLocaleDateString()
      console.log("date:  ",date)
      this.setState({
        displayer:"Details_displayer",
        number: res.number,
        name: res.name,
        expiry: res.expiry,
        cvc: res.cvc,
        amount:res.amount,
        business_name:res.business_name,
      date:date})

    });
    // this.form.reset();
    // this.setState({
    //   done: true
    // });
  }
};
Form=()=>(<form ref={c => (this.form = c)} onSubmit={this.handleSubmit}>
<div className="form-group">
  
  <input
    type="text"
    name="customer_ID"
    className="form-control"
    placeholder="Enter the customer ID"
   
    required
    onChange={this.handleInputChange}
   
  />
 
</div>
<div className="form-group">
  <input
    type="text"
    name="transaction_ID"
    className="form-control"
    placeholder="Enter the transaction ID (received by email)"
    required
    onChange={this.handleInputChange}
   
  />
</div>
 

<br />

<input
type="checkbox"
required
 /> I have read the terms of use and I approve them
 <br />


<div className="form-actions">
  <button className="btn btn-primary btn-block">Pull details</button>
</div>
</form> )

Details_displayer=()=>(<div><h5>
  You have a collection authorization for:{this.state.business_name} <br />
In the amount:{this.state.amount} <br />
<z style={{fontSize: "12px"}}   >This amount is according to your report and not according to the customer's report, do not charge more than what was agreed with the customer!</z><br />
By:{this.state.name} <br />
Credit card number:{this.state.number} <br />
Expiry Date:{this.state.expiry} <br />
cvc:{this.state.cvc} <br />
Payment date:{this.state.date} <br /></h5>
  </div>)


  render() {
  
    return (
      <div   >
        <Login  />
      <h1>
        getCredit  <br />
        </h1>
        
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
        <h1><br />
    
        details receiver
        <br /></h1>

  <div 
        style={{display: 'flex', justifyContent: 'center'}}
     >
       <div >
       {this.state.displayer==="form"?<this.Form />:<this.Details_displayer />}

</div></div>
<br/>

<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}


// -------------------------
// export default class App extends React.Component {
//   state = {
//     number: "",
//     name: "",
//     expiry: "",
//     cvc: "",
//     issuer: "",
//     focused: "",
  
//     email:"",
//     phone:"",

//     done:false
//   };


//   handleInputFocus = ({ target }) => {
     

//     this.setState({
//       focused: target.name
//     });
//   };

//   handleInputChange = ({ target }) => {
//     switch(target.name){
//       case 'number':
//         target.value = formatCreditCardNumber(target.value);
//       break;
//       case 'expiry':
//         target.value = formatExpirationDate(target.value);
//         break;
//         case 'cvc':
//           target.value = formatCVC(target.value);
//           break;
         
//     }
   

//     this.setState({ [target.name]: target.value });
//   };

//   handleSubmit = e => {
//     e.preventDefault();
//     const {dugoly_uid,amount, business_name, logo_id, client_id}=this.props.match.params;
//     const { name, number, expiry, cvc, focused } = this.state;
   

// const data={dugoly_uid,amount, business_name, logo_id, client_id, name, number, expiry, cvc, focused}
   
// fetch("https://dugoly.com/api/save_credit", {
//       method: "POST", 
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(data)
//     }).then(res => {
//       console.log("Request complete! response:", res);
//     });
//     this.form.reset();
//     this.setState({
//       done: true
//     });
// };

//   render() {
//    const {dugoly_uid,amount, business_name, logo_id, client_id}=this.props.match.params;
    
//     const { name, number, expiry, cvc, focused } = this.state;

//     return (
//       <div   >
        
         
//           {this.state.done?<Thanks business_name={business_name} />:
//           <form ref={c => (this.form = c)} onSubmit={this.handleSubmit}>
//             <div className="form-group">
              
//               <input
//                 type="tel"
//                 name="number"
//                 className="form-control"
//                 placeholder="Card Number"
//                 pattern="[\d| ]{16,22}"
//                 required
//                 onChange={this.handleInputChange}
//                 onFocus={this.handleInputFocus}
//               />
             
//             </div>
//             <div className="form-group">
//               <input
//                 type="text"
//                 name="name"
//                 className="form-control"
//                 placeholder="Name"
//                 required
//                 onChange={this.handleInputChange}
//                 onFocus={this.handleInputFocus}
//               />
//             </div>
//             <div className="row">
//               <div className="col-6">
//                 <input
//                   type="tel"
//                   name="expiry"
//                   className="form-control"
//                   placeholder="Valid Thru"
//                   pattern="\d\d/\d\d"
//                   required
//                   onChange={this.handleInputChange}
//                   onFocus={this.handleInputFocus}
//                 />
//               </div>
//               <div className="col-6">
//                 <input
//                   type="tel"
//                   name="cvc"
//                   className="form-control"
//                   placeholder="CVC"
//                   pattern="\d{3,4}"
//                   required
//                   onChange={this.handleInputChange}
//                   onFocus={this.handleInputFocus}
//                 />
//               </div>
//             </div>
//             <br />
//             {/* <div className="form-group">
//               <input
//                 type="email"
//                 name="email"
//                 className="form-control"
//                 placeholder="email"
//                 required
//                 onChange={this.handleInputChange}
               
//               />
//               </div>
//               <div className="form-group">
//                 <input
//                 id="phoneNumber" 
//                 placeholder="Phone Number" 
//                 maxlength="16"
//                 type="tel"
//                 name="phone"
//                 className="form-control"
//                 required
//                 onChange={this.handleInputChange}
//                 />
//             </div>  */}
//             <input
//             type="checkbox"
//             required
//              /> I have read the terms of use and I approve them
//              <br />

//             {/* <input
//             type="checkbox"
//             required
//              />Credit collection is done by the referring party and under his responsibility */}
//             {/* <input type="hidden" name="issuer" value={issuer} /> */}
//             <div className="form-actions">
//               <button className="btn btn-primary btn-block">PAY</button>
//             </div>
//           </form>}
         
//         </div>
//       </div>
//     );
//   }
// }





// WEBPACK FOOTER //
// ./src/details_receiver.js